
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoggerService } from 'app/shared/services/logger.service';
import { SessionService } from 'app/shared/services/session.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'is-cancel-modal',
standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule
],
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class CancelClaimModalComponent implements OnInit {
  @ViewChild('cancelClaimModal', { static: true }) cancelClaimModal: ElementRef;

  @Output() cancelAction = new EventEmitter<'dismiss' | 'confirm'>();

  environment: any = environment;
    userType = '';
  claimsLandingPage: string = environment.NATIONWIDE.ClaimsLandingPage;
  fAQPage: string = environment.NATIONWIDE.nwFaq;

  cancellationReasonsForm: UntypedFormGroup;
  displayOptions = [];
  cancellationReasons = [
    { description: 'I need to gather more info', value: 'gatherMoreInfo' },
    { description: 'I want to talk to someone first', value: 'talkToSomeone' },
    { description: 'I’d rather not answer', value: 'skip' },
    { description: 'Other', value: 'other' }
  ];

  constructor(
    public router: Router,
    public sessionService: SessionService,
    private fb: UntypedFormBuilder,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.cancellationReasonsForm = this.fb.group({
      cancelReason: [''],
      otherReason: ['']
    });
    window.sessionStorage.setItem('showDefaultDialogue', 'true');
  }

  cancelClaimModalClose(): void {
    this.cancellationReasonsForm.reset();
    this.cancelAction.emit('dismiss');
    this.cancelClaimModal.nativeElement.closeModal();
  }

  cancelClaimModalOpen(): void {
    this.cancelClaimModal.nativeElement.openModal();
  }

  sendExit(): void {
    this.sessionService.blockBrowserBack(false);
      this.userType = this.sessionService.getUserType();
      const policyNumber = this.sessionService.getPolicyNumber();
      this.cancelAction.emit('confirm');
      this.cancelClaimModal.nativeElement.closeModal();
    const selectedReasons = {
      selectedReason: this.cancellationReasonsForm.controls.cancelReason.value,
      otherReason: this.cancellationReasonsForm.controls?.otherReason?.value
    };

    window.sessionStorage.setItem('showDefaultDialogue', 'false');
    this.logger.info('Property digital claims: Cancel modal selected reasons', selectedReasons);
    if (
          this.userType &&
          Object.keys(this.userType).length > 0 &&
          this.userType.indexOf('unregistered') === -1
    ) {
        if (policyNumber) {
            this.router.navigate(['/fileclaim/info/property-claim-list-page']);
        } else {
            this.redirect(environment.NATIONWIDE.REGISTERED_LOGO_URL);
        }
    } else {
        this.redirect(this.claimsLandingPage);
    }
  }

  redirect(pageURL: string): void {
    window.location.href = pageURL;
  }
}
